import { EventEmitter, OnInit } from '@angular/core';
import { PageNames } from '../../page-names.enum';
import { TvShopEntertainmentPack } from '../../../model/tv-shop-entertainment-pack';
import { OrderOption } from '../../../model/order-option';
import { LanguageService } from '../../../services/language/language.service';
import { PriceUtils } from '../../utils/price/price.utils';
import { ImageUtils } from '../../utils/image/image-utils';
import { Price } from "../../../model/ocapi/price";
var PackOptionComponent = /** @class */ (function () {
    function PackOptionComponent(languageService) {
        this.languageService = languageService;
        this.ownerComponent = PageNames.PACK_OPTION_SELECTION;
        this.emitOrderProduct = new EventEmitter();
        this.emitOnBack = new EventEmitter();
    }
    PackOptionComponent.prototype.ngOnInit = function () {
        this.priceDetail = this.orderOption ? this.orderOption.priceDetail : undefined;
    };
    PackOptionComponent.prototype.activate = function (active) {
        this.active = active;
    };
    Object.defineProperty(PackOptionComponent.prototype, "hasPromo", {
        get: function () {
            return this.orderOption.priceDetail && this.orderOption.priceDetail.promoDuration > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PackOptionComponent.prototype, "hasDiscount", {
        get: function () {
            if (this.orderOption.term) {
                return !!this.orderOption.discount;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PackOptionComponent.prototype, "textIntegerPart", {
        get: function () {
            var promoPrice;
            if (this.hasPromo && !this.hasDiscount) {
                promoPrice = this.orderOption.priceDetail.promoPrice.integerPart();
                return promoPrice;
            }
            promoPrice = this.orderOption.priceDetail.price.value;
            if (this.orderOption.discount) {
                promoPrice += this.orderOption.discount;
            }
            return new Price(promoPrice).integerPartNumber().toString();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PackOptionComponent.prototype, "textDecimalPart", {
        get: function () {
            var price;
            if (this.hasPromo && !this.hasDiscount) {
                price = this.orderOption.priceDetail.promoPrice.decimalPart();
                return this.getTextDecimalPart(price);
            }
            price = this.orderOption.priceDetail.price.value;
            if (this.orderOption.discount) {
                price += this.orderOption.discount;
            }
            return this.getTextDecimalPart(new Price(price.toFixed(2)).decimalPart());
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PackOptionComponent.prototype, "textIntegerPartOriginal", {
        get: function () {
            return this.orderOption.priceDetail.price.integerPart();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PackOptionComponent.prototype, "textDecimalPartOriginal", {
        get: function () {
            return this.getTextDecimalPart(this.orderOption.priceDetail ? this.orderOption.priceDetail.price.decimalPart() : undefined);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PackOptionComponent.prototype, "packOptionLogoUrl", {
        get: function () {
            var componentName = this.orderOption.name + '-' + this.getCurrentLang + '-pack-option';
            return ImageUtils.getLogoUrlForOmapiId(this.orderOption.omapiId, componentName);
        },
        enumerable: true,
        configurable: true
    });
    PackOptionComponent.prototype.onEmitOrderProduct = function (order) {
        if (this.orderOption.term) {
            order.term = this.orderOption.term;
        }
        this.emitOrderProduct.emit(order);
    };
    PackOptionComponent.prototype.onBack = function () {
        this.emitOnBack.emit();
    };
    Object.defineProperty(PackOptionComponent.prototype, "getCurrentLang", {
        get: function () {
            return this.languageService.getCurrentLanguage().toLowerCase();
        },
        enumerable: true,
        configurable: true
    });
    PackOptionComponent.prototype.getTextDecimalPart = function (price) {
        var sign = this.getCurrentLang === 'fr' ? ' €' : '';
        return PriceUtils.prefixDecimalPart(price, this.getCurrentLang) + sign;
    };
    return PackOptionComponent;
}());
export { PackOptionComponent };
